import {ChangeDetectorRef, Pipe, PipeTransform} from "@angular/core";
import {UnitQuery} from "../system/units/unit.query";
import {UnitsQuery} from "../system/units/unit.store";

@Pipe({
  name: 'unit',
  pure: false
})
export class UnitPipe implements PipeTransform {
  private val: string = '';
  private unit: UnitQuery;

  constructor(private _ref: ChangeDetectorRef, private unitsQuery: UnitsQuery) {
  }

  transform(unitId?: string): any {
    if (unitId && !this.unit) {
      this.unitsQuery.selectEntity(unitId).subscribe(value1 => {
        if (value1) {
          this.unit = value1;
          this.val = value1.Code;
          this._ref.markForCheck();
        }
      });
    }
    return this.val;
  }
}
